import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './Hero.css';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';
import Section5 from './Section5';
import Section6 from './Section6';

const defaultTitle = 'PayCIS | CIS Deductions & Subcontractor Payments | HMRC-Compliant';
const defaultDescription = 'Simplify your CIS workflow with PayCIS. We support contractors and subcontractors in handling Construction Industry Scheme deductions, gross pay verification, and monthly payments to HMRC.';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <>
<Helmet>
  <title>PayCIS | CIS Deductions & Subcontractor Payments | HMRC-Compliant UK Tool</title>

  <meta
    name="viewport"
    content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=yes"
  />

  <meta
    name="description"
    content="PayCIS helps UK contractors manage CIS deductions, subcontractor payments, and HMRC submissions. Simple, accurate and HMRC-compliant construction payroll tool."
  />

  <meta
    name="keywords"
    content="CIS calculator, CIS deductions UK, Construction Industry Scheme, subcontractor payments, HMRC CIS tool, PayCIS, contractor payroll UK, VAT CIS calculator"
  />

  <meta name="author" content="PayCIS" />

  {/* Open Graph */}
  <meta property="og:title" content="PayCIS | CIS Payments & Deductions Made Easy" />
  <meta
    property="og:description"
    content="Manage subcontractor payments, CIS deductions, and HMRC reporting easily with PayCIS."
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://paycis.co.uk/" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary" />
  <meta name="twitter:title" content="PayCIS | CIS Management Tool" />
  <meta
    name="twitter:description"
    content="Simplify CIS deductions and subcontractor payments with PayCIS."
  />

  <link rel="canonical" href="https://paycis.co.uk/" />
</Helmet>
     <div className="homepage">
<section className="paycis-hero">

  <div className="paycis-sec1">
    <div className="paycis-container">

      <div className={`paycis-hero-content ${isVisible ? 'animate-in' : ''}`}>

        <h1>
          Manage Your<br/>CIS Payments Online
        </h1>

        <p className="text-medium">
          PayCIS helps contractors manage subcontractor payments, CIS deductions,
          and HMRC monthly returns — clearly, correctly, and with records your
          accountant can rely on.
        </p>

        <div className="paycis-btn-flex">
          <Link to="/register" className="paycis-gradient-btn">
            GET STARTED
          </Link>

          <Link to="/learn-more" className="paycis-link">
            <span>LEARN MORE</span>
          </Link>
        </div>

      </div>

    </div>
  </div>

  <div className="paycis-sec2">
    <div className="paycis-container">
      <div className="paycis-row-five">

        <div className="paycis-cols">
          <div className="paycis-card">
            <div className="paycis-img">
              <img src="/images/paycis-img1.svg" className="paycis-icon" alt="" />
            </div>
            <p>
              Subcontractor <br /> applies for <br /> payment
            </p>
          </div>
        </div>

        <div className="paycis-cols">
          <div className="paycis-card">
            <div className="paycis-img">
              <img src="/images/paycis-img2.svg" className="paycis-icon" alt="" />
            </div>
            <p>
              Payments <br /> approved
            </p>
          </div>
        </div>

        <div className="paycis-cols">
          <div className="paycis-card">
            <div className="paycis-img">
              <img src="/images/paycis-img3.svg" className="paycis-icon" alt="" />
            </div>
            <p>
              Payments <br /> made
            </p>
          </div>
        </div>

        <div className="paycis-cols">
          <div className="paycis-card">
            <div className="paycis-img">
              <img src="/images/paycis-img4.svg" className="paycis-icon" alt="" />
            </div>
            <p>Details to accounts</p>
          </div>
        </div>

        <div className="paycis-cols">
          <div className="paycis-card">
            <div className="paycis-img">
              <img src="/images/paycis-img5.svg" className="paycis-icon" alt="" />
            </div>
            <p>Job done</p>
          </div>
        </div>

      </div>
    </div>
  </div>

</section>

   <Section2 />
    <Section3 />
    <Section4 />
    <Section5 />
    <Section6 />

</div>
    </>
  );
};

export default Hero;

